module.exports = __webpack_public_path__ + "img/21.8db1b50e.jpg";